import React from "react"
import InfoBox from "./InfoBox"
import styles from "./styles.scss"
import image2 from "images/image2.png"
import image3 from "images/image3.png"
import { infoPagePath } from "utils/paths"

const INFO = [
  {
    id: 1,
    image: image2,
    title: "Välkommen till fixarfolket.se!",
    body:
      "Här hittar du snabbt hantverkare och friskvårdsföretag i just DIN kommun.  En massage kanske? Eller grävning på tomten?  Det hittar du snabbt hos fixarfolket!  Skriv din kommun i sökfältet och vips! Nu är du igång.  Välkommen in!",
  },
  {
    id: 2,
    image: image3,
    title: "Du vet väl?",
    body:
      "...att du har möjlighet till rot- och rut-avdrag på arbetskostnaden? 30% på ROT och 50% på RUT. Vad som gäller exakt finns att läsa på skatteverket.se.",
    path: infoPagePath(),
  },
]

class InfoContainer extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          {INFO.map(info => (
            <InfoBox
              key={info.id}
              image={info.image}
              title={info.title}
              body={info.body}
              buttonText={info.buttonText}
              path={info.path}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default InfoContainer



// WEBPACK FOOTER //
// src/pages/LandingPage/components/InfoContainer/index.jsx